import { useDidUpdate } from "./useDidUpdate";
import { useRef } from "react";
import { useDataLoading } from "./useDataLoading";
export const useSearch = (actionToDispatch, deps, delay = 1000, condition = true) => {
    const flag = useRef(false);
    const timer = useRef();
    const { data, loading, setData, setLoading } = useDataLoading({
        data: null,
        loading: false,
    });
    useDidUpdate(() => {
        if (flag.current) {
            clearTimeout(timer.current);
        }
        setLoading(true);
        timer.current = setTimeout(async () => {
            if (condition) {
                try {
                    const returnData = await actionToDispatch();
                    if (returnData) {
                        setData(returnData || null);
                    }
                    else {
                        setLoading(false);
                    }
                }
                catch (err) {
                    setLoading(false);
                }
            }
            flag.current = false;
        }, delay);
        flag.current = true;
    }, [deps]);
    return { data, loading, setData, setLoading };
};
